import { ArrowRight, Send } from 'lucide-react';
import { Button } from '../../../components';
import { useLang } from '../../../i18n';
import './CtaSection.scss';

export interface CtaSectionProps {
  onOpenLead: () => void;
  telegramUrl?: string;
}

export default function CtaSection({ onOpenLead, telegramUrl = 'https://t.me/mrbek112' }: CtaSectionProps) {
  const { t } = useLang();

  return (
    <section className="section section--dark about-cta">
      <div className="container about-cta__inner">
        <span className="eyebrow about-cta__eyebrow">{t('about.team.t')}</span>
        <h2 className="about-cta__title">{t('about.cta.t')}</h2>
        <p className="about-cta__lead">{t('about.cta.sub')}</p>
        <div className="about-cta__actions">
          <Button
            type="button"
            variant="primary"
            size="lg"
            onClick={onOpenLead}
            iconRight={<ArrowRight size={18} />}
          >
            {t('about.cta.btn')}
          </Button>
          <a
            href={telegramUrl}
            target="_blank"
            rel="noreferrer noopener"
            className="about-cta__tg"
          >
            <Send size={18} />
            <span>{t('about.cta.tg')}</span>
          </a>
        </div>
      </div>
    </section>
  );
}
